import { Col, Row } from "react-bootstrap"
import Pane from "components/Dashboards/General/Pane"
import styles from "../editingStyles.module.scss"
import { useNavigate } from "react-router"

const { selectable } = styles

export default function EditingReviewHome() {
    const navigate = useNavigate()

    return <>
       <Row className="mt-2 mx-2">
            <Col xs={4}>
                <div onClick={() => navigate("blocks")}>
                    <Pane className={selectable}>Blocks</Pane>
                </div>
            </Col>
            <Col xs={4}>
                <div onClick={() => navigate("group/")}>
                    <Pane className={selectable}>Review Groups</Pane>
                </div>
            </Col>
            <Col xs={4}>
                <div onClick={() => navigate("reviews")}>
                    <Pane className={selectable}>All Reviews</Pane>
                </div>
            </Col>
        </Row>
    </>
}
